module.exports = __webpack_public_path__ + "static/media/aa2.edb71d81.jpg";